import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { Card, CardHeader, Stack, Text } from "@chakra-ui/react";

import { selectActiveProperties } from "../../../redux/user/userSlice";
import { getPropertyAddress } from "../../../utils/verifier";

import PropertyPaymentsCard from "./PropertiesPaymentCard";

export default function Payments() {
	const properties = useSelector(selectActiveProperties);

	const { t } = useTranslation();
	return (
		<Stack>
			<Card overflowX={{ sm: "scroll", xl: "hidden" }}>
				<CardHeader>
					<Text fontSize="xl" fontWeight="bold">
						{t("navbarMenu.payments")}
					</Text>
				</CardHeader>
			</Card>
			{properties.map((property, index) => (
				<PropertyPaymentsCard payments={property.payments} address={getPropertyAddress(property)} propertyId={property.id} key={index} />
			))}
		</Stack>
	);
}
